<template>
  <div class="index">
    <NewHeader :style="'opacity:' + headOpacity"></NewHeader>

    <!-- 主图 -->
    <div :class="['banner']">
      <!-- <BannerTitle class="banner-title" :isPlatform="ifShowPlatform"></BannerTitle> -->
      <div class="banner-bg"></div>
      <!-- <div class="banner-login" @click="toLogin()" v-if="!docName">
        <span>登 录</span>
      </div>
      <div class="banner-login logged" @click="toLogin()" v-else>
        <span>欢迎您! &nbsp; <a @click="toAdmin">{{ docName }}</a>  &nbsp; <b @click="logout()">退出</b></span>
      </div> -->
      <!-- <div class="banner-content"> -->
      <!-- <div class="banner-login" v-loading="loading" v-show="false" v-if="docName == ''"> -->

      <!--

          需要插入 登录框的位置
        -->

      <!-- <div class="banner-login" v-loading="loading" v-if="docName == ''">
          <div class="user-name" style>
            <input
              class="user-name-input"
              type="text"
              v-model="userName"
              placeholder="用户名"
              @keyup.enter="loginBtn()"
            />
            <img class="input-icon" src="../assets/img/index/user_img.png" alt />
            <span></span>
          </div>
          <div class="user-psw">
            <input
              class="psword-inuput"
              type="password"
              v-model="password"
              placeholder="密码"
              @keyup.enter="loginBtn()"
            />
            <img class="input-icon" src="../assets/img/index/psw_img.png" alt />
            <span></span>
          </div>
          <div class="user-code">
            <input
              ref="codeInputsss"
              type="text"
              v-model="verifyCode"
              placeholder="输入验证码"
              @keyup.enter="loginBtn()"
              @keyup="verifyCode=verifyCode.replace(/[\u4e00-\u9fa5]/ig,'')"
            />
            <canvas id="auth-code" @click="codeBtn()"></canvas>
          </div>

          <button @click="loginBtn()">登录</button>

        </div>
        <div class="banner-login already" v-else v-loading="loading">
          <img src="../assets/img/index/doc1.png" alt />
          <div class="mar-t-10 logged-name">{{docName}}</div>
          <div class="logged">
            <button>
            </button>
            <button @click="logout()">退出登录</button>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
    <!-- 内容 -->
    <div class="index-content">
      <!-- 总计数 -->
      <div class="statistics">
        <div @click="toRegInsDetail">
          <div>
            <img src="../assets/img/index/mechanism.png" alt />
          </div>
          <div>
            <span>{{ statisticsData.hosData }}</span
            >&nbsp;家
          </div>
          <div>已注册机构数</div>
        </div>
        <div></div>
        <div @click="toRegExp">
          <div>
            <img src="../assets/img/index/reg_experts.png" alt />
          </div>
          <div>
            <span>{{ statisticsData.expData }}</span
            >&nbsp;人
          </div>
          <div>注册专家</div>
        </div>
        <div></div>
        <div @click="showPlatformDetail">
          <div>
            <img src="../assets/img/index/consultation.png" alt />
          </div>
          <div>
            <span>{{ statisticsData.diagSumData }}</span
            >&nbsp;例
          </div>
          <div>平台总会诊数</div>
        </div>
        <div></div>
        <div @click="toPlatformAdd">
          <div>
            <img src="../assets/img/index/newly_added.png" alt />
          </div>
          <div>
            <span>{{ statisticsData.diagData }}</span
            >&nbsp;例
          </div>
          <div>今日新增会诊</div>
        </div>
		<!-- <div></div> -->
		<!-- <div @click="toTotalUploadList">
		  <div>
		    <img src="../assets/img/index/total_upload.png" alt />
		  </div>
		  <div>
		    <span>{{ statisticsData.totalUpload }}</span
		    >&nbsp;例
		  </div>
		  <div>影像上传量</div>
		</div> -->
        <div></div>
        <div @click="toOnlineExp">
          <div>
            <img src="../assets/img/index/online_experts.png" alt />
          </div>
          <div>
            <span>{{ statisticsData.onlineNum }}</span
            >&nbsp;人
          </div>
          <div>在线专家</div>
        </div>
      </div>
      <!-- 推荐专家 -->
      <div class="recommendation">
        <div class="content-title">
          <div>
            <div class="">推荐专家</div>

            <div class="clear-both"></div>
          </div>
          <div>Recommended doctor</div>
        </div>
        <div class="swiper-container docList">
          <div class="swiper-wrapper">
            <div
              style="margin-left: 1px"
              class="swiper-slide"
              v-for="(recommend, index) in recommendExpData"
              @click="docBtn(recommend, index)"
            >
              <div>
                <img
                  :src="recommend.doc_photo || docNo"
                  @error="docNoError(recommend, 'doc_photo')"
                />
                <div>{{ recommend.DOC_NAME }}</div>
              </div>
              <img
                v-show="recommendExpId == recommend.DOCTOR_ID"
                src="../assets/img/index/sanjiao.png"
                alt
              />
            </div>
            <div class="swiper-slide"></div>
          </div>
        </div>
        <div class="docMain-wrap">
          <div class="swiper-container docMain">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide dis-flex"
                v-for="(recommend, index) in recommendExpData"
              >
                <img
                  class="cur-pointer"
                  :src="recommend.doc_photo || docNo"
                  @error="docNoError(recommend, 'doc_photo')"
                  @click="
                    $router.push({
                      path: '/docIndex',
                      query: { id: recommend.DOCTOR_ID },
                    })
                  "
                />
                <div>
                  <div>{{ recommend.DOC_NAME }}</div>
                  <div>{{ recommend.DOC_TITLE }}</div>
                  <div class="text-over">{{ recommend.HOS_NAME }}</div>
                  <div>会诊数：{{ recommend.diagCount }}</div>
                  <div>回退数：{{ recommend.backCount }}</div>
                  <div>签约机构：{{ recommend.expOrgan }}</div>
                </div>
              </div>
            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <!-- Add Pagination -->
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <!-- 签约专家 -->
      <div class="signing">
        <div class="content-title">
          <div>
            <div class="">签约专家</div>

            <div class="clear-both"></div>
          </div>
          <div>Contract Doctor</div>
        </div>
        <div class="swiper-container swiper-signing" id="signing">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(hosDatas, index) in hosDatas"
              :key="index"
            >
              <div>
                <img
                  :src="hosDatas.hos_photo || hosNo"
                  @error="hosNoError(hosDatas, 'hos_photo')"
                />
              </div>
              <div class="text-over">{{ hosDatas.HOS_NAME }}</div>
            </div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
        <div class="mar-t-30 text-c">
          <img src="../assets/img/index/bottom.png" alt />
        </div>
        <div
          :class="[`init${index}`, 'swiper-container', 'swiper-doc']"
          v-for="(hosDatas, index) in hosDatas"
          v-show="swiInit || docId == index"
          :key="index"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(doc, i) in hosDatas.child"
              :key="i"
            >
              <div>
                <img
                  :src="doc.doc_photo || docNo"
                  @error="docNoError(doc, 'doc_photo')"
                />
              </div>
              <div class="doc-name">{{ doc.CUSTOMERNAME }}</div>
              <div class="mar-t-10 doc-title">{{ doc.DOC_TITLE }}</div>
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <!-- 入驻机构 -->
      <div class="moveinto">
        <div class="content-title">
          <div>
            <div class="">入驻机构</div>

            <div class="clear-both"></div>
          </div>
          <div>Entering Agency</div>
        </div>
        <div
          class="swiper-container swiper-moveinto"
          id="moveinto"
          v-show="!ifShowPlatform"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              :data-swiper-slide-index="index"
              v-for="(enterOrg, index) in enterOrganData"
            >
              <div>
                <img
                  :src="enterOrg.areaPhoto || hosNo"
                  @error="regNoError(enterOrg, 'areaPhoto')"
                />
              </div>
              <div>{{ enterOrg.area }}</div>
            </div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
        <div class="mar-t-30 text-c" v-show="!ifShowPlatform">
          <img src="../assets/img/index/bottom.png" alt />
        </div>
        <!-- 横峰县 -->
        <div
          class="show-area-hos"
          v-for="(enterOrg, index) in enterOrganData"
          v-show="ifShowPlatform"
        >
          <div
            class="father-hos-item"
            v-for="(areaDatas, i) in enterOrg.areaDatas"
          >
            <div
              class="show-hos-item cur-pointer"
              @click="showHosDetail(index, i)"
            >
              <img :src="areaDatas.hos_photo" alt />
              <span class="hos-name text-over">{{ areaDatas.HOS_NAME }}</span>
              <br />
              <span class="hos-desc line-clamp-2">{{
                areaDatas.HOS_DESC
              }}</span>
            </div>
            <div class="show-hos-item welcome" v-if="ifShowWelcome"></div>
          </div>
        </div>

        <!-- 横峰县end -->
        <div
          class="swiper-container swiper-hos"
          v-for="(enterOrg, index) in enterOrganData"
          v-show="(swiInitHos || regionId == index) && !ifShowPlatform"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="child in enterOrg.child">
              <div
                v-for="(data, i) in child"
                class="cur-pointer"
                @click="showHosDetail(index, i)"
              >
                <div>
                  <img
                    :src="data.hos_photo || hosNo"
                    @error="hosNoError(data, 'hos_photo')"
                  />
                </div>
                <div class>
                  <div class="font-s-16 text-over">{{ data.HOS_NAME }}</div>
                  <div
                    class="mar-t-20 color-666 font-s-14 text-over-many line-clamp-2"
                    v-html="data.HOS_DESC"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <NewFooter></NewFooter>
  </div>
</template>
<script>
// @ is an alias to /src
import NewFooter from "@/components/NewFooter.vue";
import BannerTitle from "@/components/BannerTitle.vue";
import docNo from "../assets/img/index/doc1.png";
import hosNo from "../assets/img/index/lunbo.png";
import regNo from "../assets/img/index/quyu.png";
import tc from "../assets/img/index/tc.png";
import NewHeader from "@/components/NewHeader.vue";
import { resolve } from "q";
export default {
  name: "index",
  props: ["isPlatform"],
  data() {
    return {
      headOpacity: 1,
      areatitle: "上饶市",
      areatitleEn: "Shangrao",
      docName: "",
      loading: false,
      remember: true,
      statisticsData: {},
      childStatisData: {},
      recommendExpData: [],
      recommendExpId: "",
      hosDatas: [],
      docId: "",
      swiInit: true,
      enterOrganData: [],
      swiInitHos: true,
      regionId: "",
      sr_code: "",
      verifyCode: "",
      organId: "", // 医院id
      ifShowWelcome: false, //是否展示欢迎入驻图片

      ifShowPlatform: false,
      userName: localStorage.getItem("userName"),
      password: localStorage.getItem("password"),
      queryParams: {},

      codeInputType: "password",
    };
  },
  components: {
    NewFooter,
    NewHeader,
    BannerTitle,
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      if (to.query.province !== undefined && to.query.province != "") {
        this.ifShowPlatform = true;
        this.areatitle = "横峰县";
        this.areatitleEn = "Hengfeng";
        document.title = "横峰县医学影像共享平台";
      } else {
        this.ifShowPlatform = false;
        this.areatitle = "上饶市";
        this.areatitleEn = "Shangrao";

        document.title = "邯郸市医疗影像云服务平台";
      }
      // console.log(this.router, "路由");
      console.log(to, "路由");
      this.statistics();
      this.recommendExp();
      this.signAboutExp();
      this.EnterOrgan();
      this.$router.go(0);
    },
  },
  methods: {
    // 跳转登录页
    toLogin() {
      let url = window.location.protocol + "//" + window.location.host;
      window.location.href = url + "/login.html";
      // alert(window.location.href.split('#')[0] + '/login')
    },

    // 设置 head 逐渐显示:
    showHeadGradual() {
      let that = this;
      window.addEventListener(
        "scroll",
        function () {
          // 190 开始 逐渐显示:
          let htmlFs = parseInt(
            document.getElementsByTagName("html")[0].style.fontSize
          );
          let scrollTop = document.documentElement.scrollTop;
          if (scrollTop > htmlFs) {
            that.headOpacity = (scrollTop - 190) / 100;
            if (that.headOpacity > 1) {
              that.headOpacity = 1;
            }
          } else {
            that.headOpacity = 0;
          }
        },
        false
      );
    },
    websocket(isOnline) {
      var that = this;
      var websocket = null;
      var userList = null;
      var websocket_connected_count = 0;
      var onclose_connected_count = 0;
      newWebSocket();
      function newWebSocket() {
        //判断当前浏览器是否支持WebSocket
        if ("WebSocket" in window) {
          let ws =
            that.$store.state.curIp.websocket +
            "/websocket/hdCloudSocketServer" +
            "?sessionId=" +
            sessionStorage.getItem('sessionId');
          if (sessionStorage.getItem('sessionId')) {
            ws =
              that.$store.state.curIp.websocket +
              "/websocket/hdCloudSocketServer" +
              "?sessionId=" +
              sessionStorage.getItem('sessionId');
          } else {
            ws =
              that.$store.state.curIp.websocket +
              "/websocket/hdCloudSocketServer";
          }
          //	    websocket = new WebSocket(webSocketUrl+sessionStorage.getItem('sessionId'));
          websocket = new WebSocket(
            // 胡帅地址：
            // "ws://192.168.16.50:8081/srWebsocket/websocket/srCloudSocketServer" +
            // 服务器地址：

            // 'ws://10.10.3.4:99/websocket/hdCloudSocketServer' +
            ws
          );
        } else {
          alert("当前浏览器 Not support websocket");
        }
      }

      //连接发生错误的回调方法
      websocket.onerror = function () {};

      //连接成功建立的回调方法
      websocket.onopen = function () {
        heartCheck.reset().start(); // 成功建立连接后，重置心跳检测
        onlines();

        // 连接成功重新调用
        that.statistics();
      };

      //接收到消息的回调方法
      websocket.onmessage = function (event) {
        heartCheck.reset().start(); // 如果获取到消息，说明连接是正常的，重置心跳检测
        var msgObj = JSON.parse(event.data);
        console.log(msgObj.To);

        //报告推送
        if (msgObj.To == "push") {
          window.top.test(msgObj);
        }

        //在线用户
        if (msgObj.To == "online") {
          userList = msgObj.userList;
          if (
            window.frames["online"] != null &&
            window.frames["online"] != undefined
          ) {
            window.frames["online"].contentWindow.getList(msgObj.userList);
          }
        }

        //单点登录
        if (msgObj.To == "sso") {
          top.location.href = "../login.html?msg=2";
        }
      };

      //连接关闭的回调方法
      websocket.onclose = function () {
        onlines();
      };

      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = function () {
        closeWebSocket();
      };

      if (isOnline === false) {
        closeWebSocket();
        that.statistics();
      }

      //将消息显示在网页上
      function setMessageInnerHTML(innerHTML) {
        document.getElementById("message").innerHTML += innerHTML + "<br/>";
      }

      //关闭WebSocket连接
      function closeWebSocket() {
        websocket.close();
      }

      //在线用户
      function onlines() {
        var message = { To: "online" };
        websocket.send(JSON.stringify(message));
      }

      //强制下线
      function offline(userId) {
        var message = { To: "offline", userId: userId };
        websocket.send(JSON.stringify(message));
      }

      //发送消息
      function send() {
        var message = document.getElementById("text").value;
        websocket.send(message);
      }

      // 心跳检测, 每隔一段时间检测连接状态，如果处于连接中，就向server端主动发送消息，来重置server端与客户端的最大连接时间，如果已经断开了，发起重连。
      var heartCheck = {
        timeout: 50000, // 1分钟发一次心跳，比server端设置的连接时间稍微小一点，在接近断开的情况下以通信的方式去重置连接时间。
        serverTimeoutObj: null,
        reset: function () {
          //      clearTimeout(this.timeoutObj);
          clearTimeout(this.serverTimeoutObj);
          return this;
        },
        start: function () {
          var self = this;
          this.serverTimeoutObj = setInterval(function () {
            if (websocket.readyState == 1) {
              console.log("连接状态，发送消息保持连接");
              var message = { To: "ping" };
              websocket.send(JSON.stringify(message));
              heartCheck.reset().start(); // 如果获取到消息，说明连接是正常的，重置心跳检测
            } else {
              console.log("断开状态，尝试重连");
              newWebSocket();
            }
          }, this.timeout);
        },
      };
    },
    // 设置参数
    setParams() {
      // params.append(key, value);
      let that = this;
      let params = new URLSearchParams();
      let province = that.$route.query.province;
      let city = that.$route.query.city;
      let area = that.$route.query.area;
      if (province !== undefined && province !== "") {
        this.ifShowPlatform = true;
        this.areatitle = "横峰县";
        this.areatitleEn = "Hengfeng";

        params.append("province", province);
        params.append("city", city);
        params.append("area", area);
      } else {
        this.ifShowPlatform = false;
        this.areatitle = "上饶市";
        this.areatitleEn = "Shangrao";

        params = {};
      }

      return params;
    },

    setQueryParams() {
      let that = this;
      let params = {};
      params.province = that.$route.query.province;
      params.city = that.$route.query.city;
      params.area = that.$route.query.area;

      return params;
    },

    docNoError(d, name) {
      //图片error处理
      d[name] = docNo;
    },
    hosNoError(d, name) {
      //图片error处理
      d[name] = hosNo;
    },
    regNoError(d, name) {
      //图片error处理
      d[name] = regNo;
    },

    // 跳转详情页:
    toDetailPage(url) {
      let that = this;
      let params = that.setQueryParams();
      console.log(params);
      that.$router.push({ path: url, query: params });
    },

    // 总数展示栏
    statistics() {
      let that = this;

      let params = that.setParams();
      that.$ajax
        .post("homePage/homePageStatis", params)
        .then((response) => {
          that.statisticsData = response;

          console.log(response, "总数数据");
        })
        .catch((error) => {});
    },

    // 已注册机构数详情
    toRegInsDetail() {
      this.toDetailPage("/regInstitution");
    },

    // 平台会诊总数详情
    showPlatformDetail() {
      this.toDetailPage("/platformTotal");
    },

    // 在线专家详情
    toOnlineExp() {
      this.toDetailPage("/expertsOnline");
    },
	
	// 上传总量详情
	toTotalUploadList() {
	  this.toDetailPage("/totalUploadList");
	},

    // 注册专家详情
    toRegExp() {
      this.toDetailPage("/mechanismdetail");
    },
    // 注册专家详情
    toPlatformAdd() {
      this.toDetailPage("/platformAdd");
    },

    childStatis() {
      //子平台
      let that = this;
      let params = new URLSearchParams();
      params.append("province", "江西省");
      params.append("city", "上饶市");
      params.append("area", "横峰县");
      that.$ajax
        .post("homePage/homePageChildStatis", params)
        .then((response) => {
          that.childStatisData = response;
        })
        .catch((error) => {});
    },

    // banner 轮播图
    createBannerSwiper() {
      let that = this;
      that.bannerSwiperSr = new that.$swiper(".sr-swiper", {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          // loopAdditionalSlides: 20,
          disableOnInteraction: false, // 用户操作是否停止轮播
        },
        loop: true,
        pagination: {
          el: ".banner-pagination",
          clickable: true,
        },
      });
      that.bannerSwiperHf = new that.$swiper(".hf-swiper", {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          // loopAdditionalSlides: 20,
          disableOnInteraction: false, // 用户操作是否停止轮播
        },
        loop: true,
        pagination: {
          el: ".banner-pagination",
          clickable: true,
        },
      });
    },

    // 跳转后台:
    toAdmin() {
      let url = window.location.protocol + "//" + window.location.host;
      window.location.href = url + "/admin/index.html";
    },

    // 转到子平台
    toChildPlatform() {
      let that = this;
      // this.$router.push("Hengfeng");

      this.$router.push({
        path: "/",
        query: { province: "江西省", city: "上饶市", area: "横峰县" },
      });
      that.statistics();
      that.recommendExp();
      that.signAboutExp();
      that.EnterOrgan();
    },

    recommendExp() {
      //推荐专家
      let that = this;
      let params = that.setParams();
      that.$ajax
        .post("homePage/queryRecommendExpert", params)
        .then((response) => {
          that.recommendExpData = response.expDatas;
          console.log("------推荐专家-------", that.recommendExpData);
          that.recommendExpId = that.recommendExpData[0].DOCTOR_ID;
          setTimeout(function () {
            that.docList = new that.$swiper(".docList", {
              slidesPerView: 5,
              spaceBetween: 30,
              slidesPerGroup: 1,
              loop: false,
              loopFillGroupWithBlank: false,
            });
            that.docMain = new that.$swiper(".docMain", {
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              on: {
                slideChangeTransitionEnd: function () {
                  that.docList.slideTo(this.activeIndex, 1000, false);
                  that.recommendExpId =
                    that.recommendExpData[this.activeIndex].DOCTOR_ID;
                },
              },
            });
          }, 500);
        })
        .catch((error) => {});
    },

    // 签约专家
    signAboutExp() {
      let that = this;
      let params = that.setParams();
      that.$ajax
        .post("homePage/querySignAboutExpert", params)
        .then((response) => {
          console.log(response, "==------签约专家", "params", params);
          for (let i = 0; i < response.hosDatas.length; i++) {
            response.hosDatas[i].child = [];

            for (let j in response.expDatas) {
              if (
                response.hosDatas[i].HOS_NAME == response.expDatas[j].HOS_NAME
              ) {
                response.hosDatas[i].child.push(response.expDatas[j]);
              }
            }
            if (response.hosDatas[i].child.length == 0) {
              response.hosDatas.splice(i, 1);
              i--;
            }
          }
          if (response.hosDatas.length == 1) {
            response.hosDatas.push(
              { hos_photo: tc, child: [] },
              { hos_photo: tc, child: [] }
            );
          } else if (response.hosDatas.length == 2) {
            response.hosDatas.push({ hos_photo: tc, child: [] });
          }
          that.hosDatas = response.hosDatas;
          setTimeout(function () {
            new that.$swiper(".swiper-signing", {
              slidesPerView: 3,
              spaceBetween: 30,
              centeredSlides: true,
              loop: true,
              loopFillGroupWithBlank: false,
              loopAdditionalSlides: 100,
              normalizeSlideIndex: false,
              slideToClickedSlide: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              on: {
                slideChangeTransitionEnd: function () {
                  that.docId = Number(
                    document
                      .getElementById("signing")
                      .querySelector(".swiper-slide-active")
                      .getAttribute("data-swiper-slide-index")
                  );
                  console.log(that.docId);
                  for (let i in that.spis) {
                    console.log(that.spis);
                    setTimeout(function () {
                      that.spis[i].update();
                    }, 400);
                  }
                },
              },
            });
            that.spis = [];
            for (let i = 0; i < that.hosDatas.length; i++) {
              let slidesPerView = that.hosDatas[i].child.length;
              if (slidesPerView % 2 === 0) {
                slidesPerView -= 1;
              }
              if (slidesPerView > 5) {
                slidesPerView = 5;
              }
              that.spis.push(
                new that.$swiper(".init" + i, {
                  slidesPerView: slidesPerView,
                  spaceBetween: 30,
                  centeredSlides: true,
                  loop: true,
                  loopAdditionalSlides: 100,
                  pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                  },
                })
              );
            }
            that.swiInit = false;
          }, 500);
        })
        .catch((error) => {});
    },

    // 入驻机构
    EnterOrgan() {
      let that = this;
      that.ifShowWelcome = false;
      let params = that.setParams();
      that.$ajax
        .post("homePage/queryRollHosList", params)
        .then((response) => {
          // 如果没有简介则加上：暂无简介。
          for (let i in response.enterOrgans) {
            for (let j in response.enterOrgans[i].areaDatas) {
              if (response.enterOrgans[i].areaDatas[j].HOS_DESC == "") {
                response.enterOrgans[i].areaDatas[j].HOS_DESC = "暂无简介";
              }
            }
          }

          // 如果只有一张图片则：添加： 欢迎入驻图片：
          console.log("--------------", response.enterOrgans.length);
          if (response.enterOrgans.length === 1) {
            that.ifShowWelcome = true;
          }

          for (let i in response.enterOrgans) {
            response.enterOrgans[i].child = {};
            for (let j = 0; j < response.enterOrgans[i].areaDatas.length; j++) {
              if (j % 6 == 0) {
                response.enterOrgans[i].child[parseInt(j / 6)] = [];
              }
              response.enterOrgans[i].child[parseInt(j / 6)].push(
                response.enterOrgans[i].areaDatas[j]
              );
            }
          }
          if (response.enterOrgans.length == 1) {
            response.enterOrgans.push(
              { areaPhoto: tc, child: {} },
              { areaPhoto: tc, child: {} }
            );
          } else if (response.enterOrgans.length == 2) {
            response.enterOrgans.push({ areaPhoto: tc, child: {} });
          }
          that.enterOrganData = response.enterOrgans;

          setTimeout(function () {
            let moveintoSwiper = new that.$swiper(".swiper-moveinto", {
              slidesPerView: 3,
              spaceBetween: 30,
              centeredSlides: true,
              loop: true,
              loopAdditionalSlides: 100,
              slideToClickedSlide: true,
              // autoplay: {
              //   delay: 2000 //1秒切换一次
              // },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              on: {
                slideChangeTransitionEnd: function () {
                  that.regionId = Number(
                    document
                      .getElementById("moveinto")
                      .querySelector(".swiper-slide-active")
                      .getAttribute("data-swiper-slide-index")
                  );
                  console.log(that.regionId, "---2222");
                },
                click: function () {
                  // alert(this.clickedIndex)
                  // that.regionId = this.clickedIndex
                  // this.slideTo(that.clickedIndex, 500, false)
                },

                // click: function() {
                //   // 点击滑动swiper

                //   moveintoSwiper.slideNext()
                //   that.regionId = Number(
                //     document
                //       .getElementById('moveinto')
                //       .querySelector('.swiper-slide-active')
                //       .getAttribute('data-swiper-slide-index')
                //   )
                //   console.log(that.regionId, '---')
                // }
              },
            });

            // 入住机构的医院列表
            new that.$swiper(".swiper-hos", {
              slidesPerView: 1,
              spaceBetween: 30,
              centeredSlides: true,
              loop: false,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              on: {
                // 点击事件：
                click: function () {
                  // 获取医院id：
                  that.showHosDetail(index, i);
                },
              },
            });
            that.swiInitHos = false;
          }, 400);
        })
        .catch((error) => {});
    },

    //跳转医院详情
    showHosDetail(index, i) {
      let that = this;

      // 获取医院id
      let organId = that.enterOrganData[index].areaDatas[i].HOSPITAL_ID;
      that.$router.push({
        path: "/hosIndex",
        query: { organ_id: organId },
      });
      document.title = that.$route.meta.title;
    },

    docBtn(doc, index) {
      this.recommendExpId = doc.DOCTOR_ID;
      this.docMain.slideTo(index, 1000, false);
    },
    codeBtn() {
      let that = this;
      that.$ajax
        .post("generateVeriCode", {})
        .then((response) => {
          that.sr_code = response.sr_code;
          let options = {
            canvasId: "auth-code" /**canvas的id*/,
            txt: response.verifyCode /**传入验证码内容*/,
            height: 35 /**验证码高度 */,
            width: 80 /**验证码宽度 */,
          };
          that.$common.writeAuthCode(options);
        })
        .catch((error) => {});
    },
    loginBtn() {
      this.websocket(true);
      let that = this;
      if (this.userName == "") {
        this.$message({
          message: "用户名为必填项！",
          type: "warning",
          offset: 300,
        });
      } else if (this.password == "") {
        this.$message({
          message: "密码为必填项！",
          type: "warning",
          offset: 300,
        });
      } else if (this.verifyCode == "") {
        this.$message({
          message: "验证码为必填项！",
          type: "warning",
          offset: 300,
        });
      } else {
        this.loading = true;
        var params = new URLSearchParams();
        params.append("KEYDATA", that.userName + ",fjlzy," + that.password);
        params.append("verifyCode", that.verifyCode);
        params.append("sr_code", that.sr_code);
        that.$ajax
          .post("loginServer", params)
          .then((response) => {
            that.statistics();
            this.loading = false;
            if (response.result == "success") {
              if (that.remember) {
                localStorage.setItem("userName", that.userName);
                localStorage.setItem("password", that.password);
              } else {
                localStorage.removeItem("userName");
                localStorage.removeItem("password");
              }
              that.docName = response.user.name;
              // alert(that.docName);
              sessionStorage.setItem('sessionId', response.sessionId)
              // alert(sessionId);
              // that.$common.setCookie('token',response.user.token,7)
              that.verifyCode = "";
            } else {
              this.$message({
                message: response.content,
                type: "error",
                offset: 300,
              });
            }
          })
          .catch((error) => {
            // alert(JSON.stringify(err/or));
            this.loading = false;
          });
      }
    },
    getOnline() {
      if (sessionStorage.getItem('sessionId')) {
        var params = new URLSearchParams();
        params.append("sessionId", sessionStorage.getItem('sessionId'));
        this.$ajax
          .post("getSessionIdIsExist", params)
          .then((response) => {
            if (response.result) {
              this.docName = response.user.name;
              // console.log('--------------------get-online---------------------', response.user.username)
            }
          })
          .catch((error) => {});
      }
    },
    logout() {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("sessionId", sessionStorage.getItem('sessionId'));
      this.$ajax
        .post("logout", params)
        .then((response) => {
          this.loading = false;
          if (response.result) {
            this.docName = "";
            // alert("111--" + sessionId);
            sessionStorage.removeItem('sessionId');
            // this.$common.removeCookie("token");
            this.websocket(false);
            // this.$router.go(0);
            this.statistics();
          }
          this.codeBtn();
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
  created() {
    let that = this;
    // that.showHeadGradual()

    this.websocket(true);
    if (
      this.$route.query.province !== "" &&
      this.$route.query.province !== undefined
    ) {
      document.title = "横峰县医学影像共享平台";
    } else {
      document.title = "邯郸市医疗影像云服务平台";
    }
    this.getOnline();
    this.statistics();
    this.childStatis();
    this.recommendExp();
    this.signAboutExp();
    this.EnterOrgan();
    setTimeout(function () {
      that.createBannerSwiper();
    }, 100);
  },
  mounted() {
    // this.websocket(true);

    // this.codeBtn();
    new this.$swiper(".swiper1", {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
      loop: true,
      loopAdditionalSlides: 100,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
};
</script>
<style  lang="stylus">
.index {
  margin-top: 64px;

  // 鼠标指针
  .cur-pointer {
    cursor: pointer;
  }

  // font-family: '微软雅黑';
  // font-weight: bold;
  .head {
    height: 64px;
    background: rgba(255, 255, 255, 0.8);
    color: #fff;
    z-index: 99;
    width: 100%;
    position: fixed;
    top: 0;

    >div {
      width: 1200px;
      margin: 0 auto;

      img {
        width: auto;
        height: 48px;
        float: left;
        margin-top: 10px;
      }

      .login-ent {
        a {
          cursor: pointer;
          display: inline-block;
          float: right;
          height: 64px;
          width: 140px;
          line-height: 64px;
          color: #000;
          text-align: center;
          font-size: 16px;
        }
      }
    }
  }

  .el-loading-mask {
    position: absolute !important;
  }

  .banner {
    width: 100%;
    background: #fff;
    z-index: 99;
    height: 570px;

    .banner-title {
      width: 1536px;
    }

    .banner-bg {
      position: absolute;
      width: 100%;
      height: 570px;
      background: url('../assets/img/index/bg-banner.png') no-repeat;
      background-size: 100% 100%;

      .swiper-container {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 9;

        &.hf-swiper {
          z-index: 10;
        }

        &.sr-swiper {
          z-index: 11;
        }

        .swiper-slide {
          img {
            width: 100%;
            height: 100%;
          }
        }

        .banner-pagination {
          .swiper-pagination-bullet {
            background-color: #fff;
          }
        }
      }
    }

    :h2 {
      position: relative;
      display: block;
      top: 150px;
      width: 800px;
      height: 87px;
      background: url('../assets/img/index/slgan.png') no-repeat center;
      font-family: Microsoft Yahei, sans-serif;
      color: #ffffff;
      font-size: 32px;
      font-weight: bold;
    }

    .banner-login {
      position: relative;
      width: 1200px;
      // height 100px
      margin: 0 auto;
      height: 64px;
      z-index: 100;

      span {
        display: inline-block;
        width: 80px;
        height: 30px;
        font-size: 14px;
        font-weight: 600;
        // letter-spacing 3px
        cursor: pointer;
        border-radius: 5px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        background: rgb(51, 153, 255);
        position: absolute;
        top: 40px;
        right: 30px;
        box-shadow: 2px 3px 3px rgba(0, 0, 0, 0.2);
      }

      &.logged {
        span {
          width: auto;
          cursor: default;
          background: none;
          box-shadow: none;

          a {
            padding: 20px 3px;
            cursor: pointer;
          }

          b {
            padding: 20px 5px;
            cursor: pointer;

            &:hover {
              color: #eee;
            }
          }
        }
      }
    }

    .banner-content {
      margin: 0 auto;
      height: 600px;
      position: relative;

      .banner-login {
        float: right;
        margin-top: 150px;
        margin-right: 360px;
        width: 300px;
        height: 230px;
        background: #fff;
        background: rgba(255, 255, 255, 0.9);
        padding-top: 30px;
        position: relative;
        z-index: 99;

        >div {
          position: relative;
          line-height: 0px;
          height: 30px;
          overflow: hidden;
          height: 50px;

          &.el-loading-mask {
            height: 230px;

            .el-loading-spinner {
              height: 230px;
            }
          }

          a {
            color: #fff;
          }

          .input-icon {
            position: absolute;
            z-index: 1002;
            width: 22px;
            height: 22px;
            left: 45px;
            top: 7px;
          }

          span {
            position: absolute;
            z-index: 1002;
            width: 1px;
            left: 75px;
            top: 10px;
            color: #aaa;
            border-left: 1px solid #aaa;
            height: 17px;
          }

          input {
            font-size: 14px;
            width: 170px;
            height: 35px;
            // border-radius 25px
            border: 1PX solid #ddd;
            margin-left: 25px;
            padding-left: 65px;
            padding-right: 10px;
            color: #666;

            &.user-name-input {
              // position absolute
              // z-index 1000
              position: relative;
            }

            &.ps-word-input, &:nth-child(3) {
              border-radius: 0;
            }

            &:focus {
              border: 1PX solid rgb(51, 144, 255);
            }
          }

          &.user-code {
            overflow hidden {
              height: 35px;
            }

            heigth, input {
              padding-left: 20px;
              padding-right: 20px;
              width: 119px;
              border-radius: 0px;
            }

            canvas {
              position: absolute;
              cursor: pointer;
              width: 66px;
              height: 35px;
              left: 205px;
              // border-radius 25px
              top: 3px;
            }
          }
        }

        .el-checkbox {
          margin-left: 30px;

          .el-checkbox__label {
            font-size: 12px;
            color: #888;
          }
        }

        .forgetPsw {
          color: #FB4A4A;
          font-size: 12px;
          position: absolute;
          right: 25px;
          bottom: 88px;
        }

        button {
          margin-top: 10px;
          height: 30px;
          width: 240px;
          text-align: center;
          line-height: 30px;
          margin-left: 30px;
          border: 0;
          background: -webkit-linear-gradient(to right, #3DC2DE, #339CEA); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(to right, #3DC2DE, #339CEA); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(to right, #3DC2DE, #339CEA); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #3DC2DE, #339CEA); /* 标准的语法 */
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          position: absolute;
          bottom: 30px;
        }

        .register {
          color: #666;
          font-size: 12px;
          display: flex;
          float: right;
          margin: 10px 25px 20px 0px;
        }
      }

      .already {
        text-align: center;
        font-size: 18px;

        >div {
          over-flow: visible;
          height: 30px;
          padding-top: 15px;
          margin-bootom: 0;
        }

        img {
          width: 80px;
          height: 80px;
          margin-top: 20px;
        }

        button {
          position: relative;
          margin: 0px;
          width: 100px;
          margin: 30px 10px;
          cursor: pointer;

          &:last-child {
            background: #888;
          }
        }
      }
    }
  }

  .index-content {
    >div {
      width: 1200px;
      margin: auto;
    }

    .statistics {
      display: flex;
      margin-top: 100px;

      >div {
        cursor: pointer;
        width: 240px;
        text-align: center;

        &:nth-child(even) {
          width: 1px;
          border-right: 1px solid #386AD5;
          height: 100px;
          margin-top: 10px;
        }

        >div {
          font-weight: bold;
          margin-bottom: 8px;
          color: #333;
          font-size: 14px;

          span {
            font-size: 22px;
            font-weight: 600;
          }

          img {
            width: 60px;
            height: 60px;
          }

          &:last-child {
            margin-bottom: 0px;
            color: #888;
          }
        }
      }
    }
  }

  .content-title {
    text-align: center;
    margin: 100px auto 60px;

    >div {
      &:first-child {
        margin: auto;
        font-size: 25px;
        color: #285181;
        background: url('../assets/img/index/bg-title.png') no-repeat center center;
        background-size: 100% 50%;

        >div {
          width: 180px;
          background-color: #fff;
          margin: 0 auto;
        }
      }

      &:last-child {
        margin-top: 10px;
        color: #2DB9D4;
        font-size: 16px;
      }
    }
  }

  .platform {
    position: relative;

    >div {
      &:first-child {
        display: flex;
        font-weight: bold;

        >div {
          &:first-child {
            position: relative;

            img {
              width: 542px;
              height: 316px;
            }

            .floating {
              top: 43%;
            }
          }

          &:last-child {
            width: 638px;
            position: relative;
            margin-left: 20px;

            .right-top {
              position: absolute;
              top: 0px;
              right: 0px;
              width: 100px;
              height: 100px;
            }

            >div {
              &:first-child {
                background: #E9F8FB;
                height: 246px;
                padding: 0px 38px;

                >div {
                  float: left;
                  width: 45%;
                  font-size: 14px;
                  color: #333;
                  margin: 40px 0px 0px 20px;

                  >div {
                    >div {
                      &:last-child {
                        color: #888;
                      }
                    }
                  }

                  img {
                    width: 60px;
                    height: 60px;
                  }

                  span {
                    font-weight: 600;
                    font-size: 22px;
                  }

                  >div {
                    margin: 10px 0px 0px 20px;
                  }
                }
              }

              &:last-child {
                margin-top: 20px;
                background: -webkit-linear-gradient(to right, #3DC2DE, #339CEA); /* Safari 5.1 - 6.0 */
                background: -o-linear-gradient(to right, #3DC2DE, #339CEA); /* Opera 11.1 - 12.0 */
                background: -moz-linear-gradient(to right, #3DC2DE, #339CEA); /* Firefox 3.6 - 15 */
                background: linear-gradient(to right, #3DC2DE, #339CEA); /* 标准的语法 */
                height: 50px;
                line-height: 50px;
                color: #fff;
                text-align: center;
                font-size: 18px;
              }
            }
          }
        }
      }

      .child-platform a {
        color: #fff;
        cursor: pointer;
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      position: initial;
      margin-top: 20px;

      .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        background: #F3F3F3;
        position: relative;

        img {
          width: 100%;
        }

        >div {
          font-size: 16px;
          color: #333;
          padding-bottom: 12px;
          padding-top: 5px;
        }
      }

      .swiper-button-prev {
        width: 50px;
        height: 50px;
        left: -80px;
        top: 452px;
        background-image: url('../assets/img/index/left.png');
        background-size: 100%;
      }

      .swiper-button-next {
        width: 50px;
        height: 50px;
        right: -80px;
        top: 452px;
        background-image: url('../assets/img/index/right.png');
        background-size: 100%;
      }
    }

    .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: -55px;

      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        margin: 0 10px;

        &.swiper-pagination-bullet-active {
          background: #2DB9D4;
        }
      }
    }
  }

  .recommendation {
    padding-top: 50px;
    position: relative;

    .more {
      position: absolute;
      top: 155px;
      right: 0px;
      width: 105px;
      height: 35px;
    }

    .docList {
      .swiper-slide {
        color: #333333;
        font-size: 18px;
        height: 167px;

        &:first-child {
          margin-left: 50px;
        }

        >div {
          display: flex;

          >div {
            margin: 52px 0px 0px 20px;
            white-space: nowrap;
          }

          img {
            min-width: 110px;
            min-height: 110px;
            width: 110px;
            height: 110px;
            border-radius: 50%;
            border: 1PX solid #eee;
          }
        }

        &>img {
          width: 28px;
          height: 18px;
          position: absolute !important;
          left: 45px !important;
          margin-top: 26px !important;
        }
      }
    }

    .docMain-wrap {
      position: relative;

      .docMain {
        background: #E9F8FB;
        height: 340px;
        overflow: hidden;
        position: initial;

        .swiper-slide {
          margin: auto;
          color: #333333;
          font-size: 18px;

          &>img {
            width: 200px;
            height: 200px;
            margin: 70px 75px 0px 370px;
            border-radius: 50%;
          }

          >div {
            margin-top: 68px;

            >div {
              color: #333;
              font-size: 16px;
              margin-bottom: 16px;

              &:first-child {
                color: #285181;
                font-size: 24px;
              }
            }
          }
        }

        .swiper-button-prev {
          width: 50px;
          height: 50px;
          background-size: 100%;
          left: 90px;
          top: auto;
          bottom: 145px;
          background-image: url('../assets/img/index/left2.png');
          background-size: 100%;
        }

        .swiper-button-next {
          background-image: url('../assets/img/index/right2.png');
          width: 50px;
          height: 50px;
          right: 90px;
          top: auto;
          bottom: 145px;
          background-size: 100%;
        }
      }

      .swiper-pagination {
        padding-top: 20px;
        width: 100%;
        height: 30px;

        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          margin: 0 10px;

          &.swiper-pagination-bullet-active {
            background: #2DB9D4;
          }
        }
      }
    }

    .swiper-container-horizontal > .swiper-pagination-bullets {
      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        margin: 0 10px;

        &.swiper-pagination-bullet-active {
          background: #2DB9D4;
        }
      }
    }
  }

  .signing {
    padding-top: 50px;
    position: relative;

    .text-c {
      img {
        width: 30px;
        height: 15px;
      }
    }

    .more {
      position: absolute;
      top: 155px;
      right: 0px;
      width: 105px;
      height: 35px;
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      position: initial;

      .swiper-slide {
        text-align: center;
        font-size: 18px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        transition: 300ms;
        transform: scale(0.8);
        border-radius: 10px;

        .doc-title {
          color: #999;
        }

        img {
          width: 100%;
          height: 250px;
          margin-bottom: 20px;
          border-radius: 10px;
        }
      }

      .swiper-slide-active, .swiper-slide-duplicate-active {
        transform: scale(1);
      }

      .swiper-button-prev {
        width: 28px;
        height: 50px;
        left: -80px;
        top: 400px;
        background-image: url('../assets/img/index/left.png');
        background-size: 100%;
      }

      .swiper-button-next {
        width: 28px;
        height: 50px;
        right: -80px;
        top: 400px;
        background-image: url('../assets/img/index/right.png');
        background-size: 100%;
      }
    }

    .swiper-doc {
      margin-top: 50px;
      width: 100%;
      height: 100%;
      position: initial;

      .swiper-slide {
        font-size: 22px;

        img {
          width: 180px;
          height: 180px;
          border-radius: 50%;
        }
      }
    }

    .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: -6%;

      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        margin: 0 10px;

        &.swiper-pagination-bullet-active {
          background: #2DB9D4;
        }
      }
    }
  }

  .moveinto {
    padding: 50px 0px 130px 0px;
    position: relative;

    .text-c {
      img {
        width: 30px;
        height: 15px;
      }
    }

    .more {
      position: absolute;
      top: 155px;
      right: 0px;
      width: 105px;
      height: 35px;
    }

    .swiper-moveinto {
      width: 100%;
      height: 100%;
      position: initial;

      .swiper-slide {
        text-align: center;
        font-size: 18px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        transition: 300ms;
        transform: scale(0.8);
        border-radius: 10px;

        img {
          width: 100%;
          height: 250px;
          margin-bottom: 20px;
          border-radius: 10px;
        }
      }

      .swiper-slide-active, .swiper-slide-duplicate-active {
        transform: scale(1);
      }

      .swiper-button-prev {
        width: 28px;
        height: 50px;
        left: -80px;
        top: 400px;
        background-image: url('../assets/img/index/left.png');
        background-size: 100%;
      }

      .swiper-button-next {
        width: 28px;
        height: 50px;
        right: -80px;
        top: 400px;
        background-image: url('../assets/img/index/right.png');
        background-size: 100%;
      }
    }

    .swiper-hos {
      margin-top: 50px;
      width: 100%;
      height: 280px;
      position: initial;

      .swiper-slide {
        font-size: 16px;

        >div {
          display: flex;
          background: #EFEFEF;
          float: left;
          width: 30.8%;
          margin: 10px;
          padding: 5px;

          >div {
            >div {
              margin: 20px 0px 0px 20px;
            }
          }

          img {
            width: 184px;
            height: 120px;
          }
        }
      }

      .swiper-pagination {
        display: none;
      }

      .swiper-container-horizontal > .swiper-pagination-bullets {
        bottom: 85px;

        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          margin: 0 10px;

          &.swiper-pagination-bullet-active {
            background: #2DB9D4;
          }
        }
      }
    }
  }

  .floating {
    background: #269CEC;
    opacity: 0.8;
    color: #fff !important;
    position: absolute;
    top: 0px;
    width: 100%;
    top: 33%;
    font-size: 22px !important;
    height: 60px;
    line-height: 60px;
    padding: 0 !important;
    text-align: center;
  }
}

.personal {
  position: absolute;
  right: 200px;
  height: 40px;
  top: 14px;
  width: 100px;
  // background-color: rgb(95,167,232);
  text-align: center;
  border-radius: 5px;

  a {
    // color: #fff;
    color: #000;
    line-height: 40px;
    font-size: 17px;
  }
}

.show-area-hos {
  width: 100%;
  margin: 0 auto 80px;
  text-align: center;

  .father-hos-item {
    text-align: left;
    display: inline-block;
    margin: 0 auto;

    .show-hos-item {
      margin: 10px;
      float: left;
      display: inline block;
      padding: 10px;
      position: relative;
      width: 330px;
      height: 100px;
      background-color: #dbdbdb;
      border-radius: 5px;

      // margin-left: -150px;
      img {
        width: 130px;
        heigth: 80px;
        border-radius: 5px;
      }

      &.welcome {
        background: url('../assets/img/hengfeng/welcome.png') no-repeat;
        background-size: 100% 100%;
      }

      .hos-name {
        position: absolute;
        top: 20px;
        margin-left: 150px;
        font-size: 18px;
      }

      &:after {
        content: ' ';
        display: block;
        clear: both;
      }
    }

    .hos-desc {
      display: inline-block;
      position: absolute;
      top: 63px;
      right: 10px;
      width: 180px;
      height: 42px;
      font-size: 14px;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}

.el-loading-mask {
  height: 230px;

  .el-loading-spinner {
    height: 230px;
  }
}
</style>
